import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config/api';
import { authFetch } from '../utils/authFetch';

export interface BalanceOverviewPoint {
  date: string;
  totalBalance: number;
}

// Fetches the past 6 months of monthly balances
export function useBalanceOverview() {
  return useQuery<BalanceOverviewPoint[]>({
    queryKey: ['balanceOverview', '6months'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/analytics/balance-overview/`);
      if (!response.ok) throw new Error('Failed to fetch balance overview');
      return response.json();
    },
  });
} 